import { trpc } from '@/shared/api';

/** 인증 메일 재발송 뮤테이션. */
export const useResendVerification = () => trpc.auth.resendVerification.useMutation();
